// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3tzoP","label":"Labeled_label__14Rq6","divider":"Labeled_divider__2bQIp"};